/* @flow */

import { type AxiosPromise } from 'axios';
import xhr from '../utils/xhr';
import { type Usuario, type Nivel } from './types';

type Params = {
    ordenacao?: string,
    quantidade?: number,
    pagina?: number,
    query?: string,
    nivel?: Nivel,
    filtro?: {
        coluna: string,
        valor: string,
        opcao: string,
    },
};

const buscarUsuarios = (params: Params): AxiosPromise<{ data: Usuario[] }> => (
    xhr.get('/usuarios', { params })
);

export default buscarUsuarios;
